<template>
  <div id="app">
    <component :is="layout" />
    <UpdateExists />
    <ModalTimeout :timeout="isIdle" />
  </div>
</template>
<script>
import UpdateExists from '@/components/UpdateExists.vue';
import ModalTimeout from '@/components/ModalTimeout.vue';

export default {
  components: {
    Student: () => import('@/layouts/Student.vue'),
    Tutor: () => import('@/layouts/Tutor.vue'),
    FullPage: () => import('@/layouts/FullPage.vue'),
    UpdateExists,
    ModalTimeout,
  },
  computed: {
    layout: function () {
      if (this.$route.meta.layout) {
        return this.$route.meta.layout;
      }
      return 'FullPage';
    },
    isIdle() {
      // Theres idle ONLY if loggued in!
      if (this.$route.name !== 'login' && this.$route.name !== 'resetPassword') {
        return this.$store.state.idleVue.isIdle;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/main.scss';
</style>
